import { t } from '@lingui/core/macro';
import { HardCodedSalesItemId } from 'noddi-types';
import { NoddiIconName } from 'noddi-ui-common';

export const getHardCodedSalesItems = (): {
  ids: number[];
  name: string;
  description: string;
  icon: NoddiIconName;
}[] => [
  {
    ids: [HardCodedSalesItemId.TireHotelPickup, HardCodedSalesItemId.TireHotelPickupEx],
    name: t`Pick up of tires from another tire hotel`,
    description: t`We'll collect your tires from another tire hotel before bringing them to you`,
    icon: 'Home'
  },
  {
    ids: [HardCodedSalesItemId.TireHotelNewCustomerSmallCar, HardCodedSalesItemId.TireHotelNewCustomerLargeCar],
    name: t`Tire hotel with wheel change`,
    description: t`We change your wheels and take care of the tires you're not using. Safely stored until next season`,
    icon: 'WheelAngle'
  },
  {
    ids: [HardCodedSalesItemId.TireHotelRenewal],
    name: t`Tire hotel renewal`,
    description: t`We bring your stored tires, change them, and store the ones we take off`,
    icon: 'WheelAngle'
  },
  {
    ids: [HardCodedSalesItemId.TireHotelCancelHomeDeliveryAndWheelChange],
    name: t`Home delivery and wheel change`,
    description: t`We'll bring your tires and do the wheel change right at your home to end the tire hotel contract`,
    icon: 'WheelAngle'
  },
  {
    ids: [HardCodedSalesItemId.RimWashSmallCar, HardCodedSalesItemId.RimWashLargeCar],
    name: t`Rim wash`,
    description: t`We wash with a steamer, so we have no need for access to water`,
    icon: 'Droplet'
  },
  {
    ids: [HardCodedSalesItemId.RepairOfPuncture],
    name: t`Repair of puncture`,
    description: t`We'll fix it where you are parked, bringing all the necessary tools`,
    icon: 'WheelAngle'
  },
  {
    ids: [
      HardCodedSalesItemId.OutsideWashExtraDirty,
      HardCodedSalesItemId.OutsideWashPlusLargeCar,
      HardCodedSalesItemId.OutsideWashPlusSmallCar,
      HardCodedSalesItemId.OutsideWashPremiumSmallCar,
      HardCodedSalesItemId.OutsideWashPremiumLargeCar,
      HardCodedSalesItemId.OutSideWashStandardLargeCar,
      HardCodedSalesItemId.OutSideWashStandardSmallCar
    ],
    name: t`Outside car wash`,
    description: t`We wash with a steamer, so we have no need for access to water`,
    icon: 'Droplet'
  },
  {
    ids: [
      HardCodedSalesItemId.InsideWashExtraDirty,
      HardCodedSalesItemId.InsideWashStandard,
      HardCodedSalesItemId.InsideWashPlusSmallCar,
      HardCodedSalesItemId.InsideWashPlusLargeCar,
      HardCodedSalesItemId.InsideWashPremiumSmallCar,
      HardCodedSalesItemId.InsideWashPremiumLargeCar,
      HardCodedSalesItemId.InsideWashVan
    ],
    name: t`Inside car wash`,
    description: t`Make sure the car is unlocked or that we have the key—we'll handle the rest`,
    icon: 'Droplet'
  }
];
